module.exports = __webpack_public_path__ + "img/4989.8b220547.jpg";